import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({

  state: {
    // 存储token
    token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
    isPlaying: false, // 音频是否正在播放
    rotationDegree: 0, // 新增旋转角度状态
  },

  mutations: {
    // 修改token，并将token存入localStorage
    changeLogin(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    setPlayState(state, isPlaying) {
      state.isPlaying = isPlaying;
    },
    setRotationDegree(state, degree) {
      state.rotationDegree = degree;
    }
  },
  actions: {
    setPlayState({ commit }, isPlaying) {
      commit('setPlayState', isPlaying);
    },
    setRotationDegree({ commit }, degree) {
      commit('setRotationDegree', degree);
    }
  }
});

export default store;